import {
  Box,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Text,
  Flex,
  HStack,
} from "@chakra-ui/react";
import { FC, ReactNode } from "react";

interface AlertComponentProps {
  title?: string;
  description: string | ReactNode;
  status: "success" | "error" | "warning" | "info" | "loading";
  borderColor: string;
  buttonElement?: ReactNode;
}

const AlertComponent: FC<AlertComponentProps> = ({
  title,
  description,
  status,
  borderColor,
  buttonElement,
}) => {
  return (
    <Alert status={status} borderTop="4px" borderColor={borderColor}>
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        <HStack>
          <AlertIcon boxSize="6" />
          <Box>
            {title && (
              <AlertTitle>
                <Text fontSize="xl">{title}</Text>
              </AlertTitle>
            )}
            <AlertDescription>{description}</AlertDescription>
          </Box>
        </HStack>
        {buttonElement}
      </Flex>
    </Alert>
  );
};

export default AlertComponent;
